export const fullFeatureList = [
  {
    id: 4,
    name: "dashboard",
    description: null,
    active: true,
    site: "com",
    attribute_class: "default",
    attribute_type: null,
    attribute_sub_type: null,
    attribute_associations: null,
    icon_name: null,
    label: null,
    feature_order: null,
    tree_names_of_levels: null,
    tree_number_of_levels: null,
    extra_destination_columns: null,
  },
  {
    id: 5,
    name: "excel",
    description: null,
    active: true,
    site: "com",
    attribute_class: "default",
    attribute_type: null,
    attribute_sub_type: null,
    attribute_associations: null,
    icon_name: null,
    label: null,
    feature_order: null,
    tree_names_of_levels: null,
    tree_number_of_levels: null,
    extra_destination_columns: null,
  },
  {
    id: 7,
    name: "runtime_item_groups",
    description: null,
    active: false,
    site: "com",
    attribute_class: "default",
    attribute_type: null,
    attribute_sub_type: null,
    attribute_associations: null,
    icon_name: null,
    label: null,
    feature_order: null,
    tree_names_of_levels: null,
    tree_number_of_levels: null,
    extra_destination_columns: null,
  },
  {
    id: 9,
    name: "in_market_hierarchy",
    description: null,
    active: true,
    site: "com",
    attribute_class: "item",
    attribute_type: "category",
    attribute_sub_type: "tree",
    attribute_associations: null,
    icon_name: null,
    label: "Category",
    feature_order: null,
    tree_names_of_levels: null,
    tree_number_of_levels: null,
    extra_destination_columns: null,
  },
  {
    id: 17,
    name: "priority",
    description: null,
    active: true,
    site: "com",
    attribute_class: "item",
    attribute_type: "category",
    attribute_sub_type: "flat",
    attribute_associations: ["chain"],
    icon_name: null,
    label: null,
    feature_order: null,
    tree_names_of_levels: null,
    tree_number_of_levels: null,
    extra_destination_columns: [
      {
        name: "priority_level_2",
        label: "Priority Level 2",
      },
    ],
  },
  {
    id: 18,
    name: "broker",
    description: null,
    active: true,
    site: "com",
    attribute_class: "customer",
    attribute_type: "category",
    attribute_sub_type: "flat",
    attribute_associations: ["chain"],
    icon_name: null,
    label: "Broker",
    feature_order: 3,
    tree_names_of_levels: null,
    tree_number_of_levels: null,
    extra_destination_columns: null,
  },
  {
    id: 19,
    name: "account_handler",
    description: null,
    active: true,
    site: "com",
    attribute_class: "customer",
    attribute_type: "category",
    attribute_sub_type: "flat",
    attribute_associations: ["chain"],
    icon_name: null,
    label: "Handler",
    feature_order: 2,
    tree_names_of_levels: null,
    tree_number_of_levels: null,
    extra_destination_columns: null,
  },
  {
    id: 20,
    name: "account_team",
    description: null,
    active: true,
    site: "com",
    attribute_class: "customer",
    attribute_type: "category",
    attribute_sub_type: "flat",
    attribute_associations: ["chain"],
    icon_name: null,
    label: "Team",
    feature_order: 1,
    tree_names_of_levels: null,
    tree_number_of_levels: null,
    extra_destination_columns: null,
  },
  // {
  //   id: 22,
  //   name: "selling_unit_gtin",
  //   description: null,
  //   active: true,
  //   site: "com",
  //   attribute_class: "item",
  //   attribute_type: "one-to-one",
  //   attribute_sub_type: null,
  //   attribute_associations: null,
  //   icon_name: null,
  //   label: "Pouch/Unit Gtin",
  //   feature_order: null,
  //   tree_names_of_levels: null,
  //   tree_number_of_levels: null,
  //   extra_destination_columns: null,
  // },
  {
    id: 24,
    name: "case_code",
    description: null,
    active: true,
    site: "com",
    attribute_class: "item",
    attribute_type: "one-to-one",
    attribute_sub_type: null,
    attribute_associations: null,
    icon_name: null,
    label: "Case Code",
    feature_order: null,
    tree_names_of_levels: null,
    tree_number_of_levels: null,
    extra_destination_columns: null,
  },
  {
    id: 26,
    name: "item_description",
    description: null,
    active: true,
    site: "com",
    attribute_class: "item",
    attribute_type: "one-to-one",
    attribute_sub_type: null,
    attribute_associations: null,
    icon_name: null,
    label: "Item Description",
    feature_order: null,
    tree_names_of_levels: null,
    tree_number_of_levels: null,
    extra_destination_columns: null,
  },
  {
    id: 39,
    name: "pouch_unit_upc",
    description: null,
    active: false,
    site: "com",
    attribute_class: "item",
    attribute_type: "one-to-one",
    attribute_sub_type: null,
    attribute_associations: null,
    icon_name: null,
    label: "Pouch/Unit UPC",
    feature_order: null,
    tree_names_of_levels: null,
    tree_number_of_levels: null,
    extra_destination_columns: null,
  },
  {
    id: 28,
    name: "case_gtin",
    description: null,
    active: true,
    site: "com",
    attribute_class: "item",
    attribute_type: "one-to-one",
    attribute_sub_type: null,
    attribute_associations: null,
    icon_name: null,
    label: "Case GTIN",
    feature_order: null,
    tree_names_of_levels: null,
    tree_number_of_levels: null,
    extra_destination_columns: null,
  },
  // {
  //   id: 29,
  //   name: "email",
  //   description: null,
  //   active: true,
  //   site: "com",
  //   attribute_class: "customer",
  //   attribute_type: "one-to-one",
  //   attribute_sub_type: null,
  //   attribute_associations: null,
  //   icon_name: null,
  //   label: "Email",
  //   feature_order: null,
  //   tree_names_of_levels: null,
  //   tree_number_of_levels: null,
  //   extra_destination_columns: null,
  // },


  // {
  //   id: 40,
  //   name: "carton_tray_upc",
  //   description: null,
  //   active: true,
  //   site: "com",
  //   attribute_class: "item",
  //   attribute_type: "one-to-one",
  //   attribute_sub_type: null,
  //   attribute_associations: null,
  //   icon_name: null,
  //   label: "Carton/Tray UPC",
  //   feature_order: null,
  //   tree_names_of_levels: null,
  //   tree_number_of_levels: null,
  //   extra_destination_columns: null,
  // },
];

export const storeAttrOptions = [
  {
    id: 1,
    name: "kellogg_chain",
  },
  {
    id: 3,
    name: "account_team",
    featureTag: "account_team",
  },
  {
    id: 4,
    name: "account_handler",
    featureTag: "account_handler",
  },
  {
    id: 5,
    name: "broker",
    featureTag: "broker",
  },
];
export const storeGroupByOptions = [
  {
    id: 1,
    name: "kellogg_chain",
  },
  {
    id: 3,
    name: "account_team",
    featureTag: "account_team",
  },
  {
    id: 4,
    name: "account_handler",
    featureTag: "account_handler",
  },
  {
    id: 5,
    name: "broker",
    featureTag: "broker",
  },
];
export const itemAttrOptions = [
  {
    id: 3,
    name: "master_brand",
  },
  {
    id: 4,
    name: "brand",
  },
  {
    id: 5,
    name: "sub_brand",
  },
  {
    id: 6,
    name: "priority_level",
    featureTag: "priority",
  },
  {
    id: 7,
    name: "case_code",
    featureTag: "case_code",
  },
  {
    id: 8,
    name: "case_gtin",
    featureTag: "case_gtin",
  },
  {
    id: 9,
    name: "selling_unit_gtin",
    featureTag: "selling_unit_gtin",
  },
  {
    id: 11,
    name: "priority_level_2",
    featureTag: "priority",
  },
  {
    id: 91,
    name: "in_market_hierarchy_level_1",
    featureTag: "in_market_hierarchy",
  },
  {
    id: 92,
    name: "in_market_hierarchy_level_2",
    featureTag: "in_market_hierarchy",
  },
  {
    id: 93,
    name: "in_market_hierarchy_level_3",
    featureTag: "in_market_hierarchy",
  },
  {
    id: 94,
    name: "in_market_hierarchy_name_path",
    featureTag: "in_market_hierarchy",
  },
];
export const storeFilterOptions = [
  {
    id: 1,
    label: "Team",
    source: "parameters.customer_filtering.team_id",
    reference: "kelloggs_account_team",
    display_field: "name",
    id_field: "id",
    name: "team",
    athena_column_name: "account_team_id",
    is_disabled: true,
    featureTag: "account_team",
  },
  {
    id: 2,
    label: "Handler",
    source: "parameters.customer_filtering.handler_id",
    reference: "kelloggs_account_handler",
    display_field: "name",
    id_field: "id",
    name: "handler",
    athena_column_name: "account_handler_id",
    is_disabled: true,
    featureTag: "account_handler",
  },
  {
    id: 3,
    label: "Broker",
    source: "parameters.customer_filtering.broker_id",
    reference: "kelloggs_broker",
    display_field: "name",
    id_field: "id",
    name: "broker",
    athena_column_name: "broker_id",
    is_disabled: true,
    featureTag: "broker",
  },
];
export const itemGroupColumnOptions = [
  {
    id: 1,
    name: "priority_level",
    featureTag: "priority",
  },
  {
    id: 2,
    name: "priority_level_2",
    featureTag: "priority",
  },
  {
    id: 4,
    name: "in_market_hierarchy_level_1",
    featureTag: "in_market_hierarchy",
  },
  {
    id: 5,
    name: "in_market_hierarchy_level_2",
    featureTag: "in_market_hierarchy",
  },
  {
    id: 6,
    name: "in_market_hierarchy_level_3",
    featureTag: "in_market_hierarchy",
  },
  {
    id: 7,
    name: "in_market_hierarchy_name_path",
    featureTag: "in_market_hierarchy",
  },
];
export const runtimeItemGroupFilterOptions = [
  {
    id: 1,
    label: "Category",
    source: "parameters.item_filtering.in_market_hierarchy_id",
    reference: "kelloggs_in_market_hierarchy",
    display_field: "name_path",
    id_field: "id",
    name: "in_market_hierarchy",
    athena_column_name: "in_market_hierarchy_id",
    is_disabled: true,
    featureTag: "in_market_hierarchy",
  },
  {
    id: 1,
    label: "Priority Level",
    source: "parameters.item_filtering.priority_level_id",
    reference: "kelloggs_priority_level",
    display_field: "name",
    id_field: "id",
    name: "priority_level",
    athena_column_name: "priority_level_id",
    is_disabled: true,
    featureTag: "priority_level",
  },
  {
    id: 1,
    label: "Priority Level 2",
    source: "parameters.item_filtering.priority_level_2_id",
    reference: "kelloggs_priority_level",
    display_field: "name",
    id_field: "id",
    name: "priority_level_2",
    athena_column_name: "priority_level_2_id",
    is_disabled: true,
    featureTag: "priority_level_2",
  },
];
